import axios from 'axios';
import { apiWrapper } from '../data/utils/apiWrapper';
import { getConfig } from '../data/utils/getConfig';

export const notificationApi = {
	getNotification: async token => {
		const config = getConfig(token);
		return await apiWrapper(axios.get(`${import.meta.env.VITE_APP_API_URL}/notification"`, config));
	}
};
